import { LucideIcon, X } from 'lucide-react';
import { Button } from '@/core/components/ui/button';

interface BladeAction {
  label: string;
  onClick: () => void;
  variant?: 'default' | 'outline' | 'secondary' | 'ghost';
  icon?: LucideIcon;
}

interface BladeHeaderProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  actions?: BladeAction[];
  onClose: () => void;
  className?: string;
  showCloseButton?: boolean;
}

export function BladeHeader({
  title,
  subtitle,
  icon: Icon,
  actions = [],
  onClose,
  className = '',
  showCloseButton = true
}: BladeHeaderProps) {
  return (
    <div className={`flex items-start justify-between pb-6 ${className}`}>
      <div className="flex items-start gap-3 flex-1">
        {Icon && (
          <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mt-1">
            <Icon className="h-5 w-5 text-gray-600" />
          </div>
        )}
        
        <div className="flex-1 min-w-0">
          <h1 className="text-xl font-semibold text-gray-900 truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-gray-600 mt-1 font-mono">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2 ml-4">
        {actions.map((action, index) => {
          const ActionIcon = action.icon;
          return (
            <Button
              key={index}
              variant={action.variant || 'outline'}
              size="sm"
              onClick={action.onClick}
              className="flex items-center gap-2"
            >
              {ActionIcon && <ActionIcon className="h-4 w-4" />}
              {action.label}
            </Button>
          );
        })}
        
        {showCloseButton && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="h-8 w-8 p-0 hover:bg-gray-100 rounded-lg ml-2"
            data-testid="blade-close-button"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}